import { render, staticRenderFns } from "./IntegrationsMail.vue?vue&type=template&id=63a3d952&scoped=true&"
import script from "./IntegrationsMail.vue?vue&type=script&lang=js&"
export * from "./IntegrationsMail.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsMail.vue?vue&type=style&index=0&id=63a3d952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3d952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VIcon,VRadio,VRadioGroup,VRow,VSubheader})
